export interface IUsersListRequest {
  page: string;
  perPage: string;
  query: string;
  deleted: boolean;
}
